import { render, staticRenderFns } from "./SamPrimaryButton.vue?vue&type=template&id=bae4024e&scoped=true&"
import script from "./SamPrimaryButton.vue?vue&type=script&lang=js&"
export * from "./SamPrimaryButton.vue?vue&type=script&lang=js&"
import style0 from "./SamPrimaryButton.vue?vue&type=style&index=0&id=bae4024e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae4024e",
  null
  
)

export default component.exports